import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, autorun, action, toJS } from 'mobx';
import Spinner from '../../../Spinner';
import Form, { FormBody, FormActions, SelectInput } from '../../../Form';
import ReactDropzone from 'react-dropzone';
import { BASE_URL } from '../../../../config';
import request from 'superagent';
import { token } from "../../../../libs/localStorage";

@inject('imageSourceDeviceStore')
@observer
class Upload extends Component {
  static propTypes = {
    route: PropTypes.object.isRequired,
  }

  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  }

  slug = '/idaq/image_source';

  @observable file = null;
  @observable isSaving = false;
  @observable albums = [];
  @observable selected_album = '';
  @observable imageSourceDevice = { imagesource_id: -1 };

  dispose;
  componentWillMount() {
    const { imageSourceDeviceStore, params: { id } } = this.props;
    if (!imageSourceDeviceStore.items.length) imageSourceDeviceStore.fetchItems()
    this.dispose = autorun(() => {
      let imageSourceDevice = imageSourceDeviceStore.items.find(item => +item.station_id === +id);
      if (!!imageSourceDevice) this.imageSourceDevice = imageSourceDevice;
    })
    imageSourceDeviceStore.fetchStationAlbum(id).then(res => {
      this.albums = res;
    })
  }

  onDrop = (files) => {
    this.file = files[0];
  };

  removeFile = () => this.file = null;

  handleSave = e => {
    e.preventDefault();

    const { notify, router } = this.context;
    const { imageSourceDeviceStore, params: { id } } = this.props;

    // const url = `${BASE_URL}/idaq/api/upload/imagesource/${this.imageSourceDevice.imagesource_id}/station/${id}/album/${this.selected_album}`;
    const url = `${BASE_URL}/idaq/api/upload?imagesource_id=${this.imageSourceDevice.imagesource_id}&station_id=${id}&album_code=${this.selected_album}`;

    const req = request.post(url).set('Authorization', `Bearer ${token.getEncoded()}`);
    req.attach('file', this.file);

    req.end((err, res) => {
      if (err) {
        console.log(err);
        notify.error(err);
      } else {
        notify.success({ message: 'Uploaded.' });
        this.removeFile();
      }
    })


  }

  render() {
    const { imageSourceDeviceStore } = this.props;
    // let source = imageSourceDeviceStore.findById(id);

    return (
      <div>
        {imageSourceDeviceStore.isLoading ? <Spinner /> : <Form>
          <FormBody>
            <SelectInput
              label={'Album'}
              value={this.selected_album}
              onChange={e => this.selected_album = e.target.value}
              options={this.albums}
              fields={{ value: 'album_code', label: 'album_code' }}
            />
            <div className='formInput flex flex-row full-width'>
              <label>Image</label>
              {/*<button onClick={this.onOpenAddFile}>{!!this.file ? this.file.name :"Choose file"}</button>*/}
              {!!this.file && !!this.file.preview ?
                <div className="imageContainer">
                  <div className="imageRemove"><span className="fa fa-remove" onClick={this.removeFile} />
                  </div>
                  <img src={this.file.preview} style={{ maxWidth: '50vw', maxHeight: '50vh' }} alt='not-found' />
                </div> :
                <ReactDropzone ref="dropzone"
                  onDrop={this.onDrop}
                  style={{
                    display: "flex",
                    flexDirection: 'column',
                    justifyContent: 'center',
                    textAlign: "center",
                    height: "35px",
                    minWidth: "310px",
                    cursor: "pointer",
                    border: '1px solid lightgrey'
                  }}>
                  <span style={{ display: "block", color: '#5d5d5d' }} id={"filename"}>
                    Click or drag a file here to upload!
                  </span>
                </ReactDropzone>}
            </div>
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>}
      </div>
    );
  }
}

export default Upload;


// WEBPACK FOOTER //
// ./src/components/Station/Image/pages/Upload.js